import React from 'react'
import Copyrights from './Copyrights'
import Subscription from './Subscription'
import CustomLinks from './CustomLinks'
import blob from '../images/blob-shape.svg'
import IconArrowUp from '../icons/arrow-up.svg'

const isServer = typeof window === 'undefined'

export default () => {
	const handleClick = event => {
		event.preventDefault()
		if (!isServer) window.scroll({ top: 0, behavior: 'smooth' })
	}

	return (
		<footer
			className="site-footer-wrap"
			style={{ backgroundImage: `url(${blob})` }}
		>
			<div class="footer-inner">
				<Subscription />
				<CustomLinks />
				<Copyrights />
			</div>
			<span
				class="back-to-top"
				id="back-to-top"
				style={{ display: `inline` }}
				onClick={handleClick}
			>
				<IconArrowUp />
			</span>
		</footer>
	)
}
